export default "__VITE_ASSET__CZ3$i$mL__"